import Globalize from '@sprinx/globalize';
import invariant from 'invariant';
export default function forLocale(cache, initialValue, callback) {
  if (callback === undefined) {
    callback = initialValue;
    initialValue = null;
  }

  invariant(cache, 'forLocale: cache object is required');
  invariant(callback && typeof callback === 'function', 'forLocale: callback function as param1 or param2 is required');
  /* istanbul ignore next */

  var cldr = Globalize.locale() || 'en';
  /* istanbul ignore next */

  var locale = typeof cldr === 'string' ? cldr : cldr.locale;

  if (!cache[locale]) {
    cache[locale] = initialValue;
  }

  return callback(cache[locale]);
}